import React from "react";
import StatusChip, { statusChipStatus } from "@common/components/statusChip/StatusChip";
import { useTranslation } from "@localization/useTranslation";
import { exhaustiveGuard } from "@common/utilities";
import { ProcessStatus } from "./Process.types";
import { getProcessStatusTranslationKey } from "./processStatus";

export interface ProcessStatusChipProps {
    status: ProcessStatus;
}

// The same colours as the processing activity's Draft, Active and Archived, so the two read alike.
function ProcessStatusChip(props: ProcessStatusChipProps) {
    const { translateString } = useTranslation();

    function getChipColor(status: ProcessStatus): statusChipStatus {
        switch (status) {
            case ProcessStatus.Draft:
                return "lightgreen";
            case ProcessStatus.Active:
                return "green";
            case ProcessStatus.Archived:
                return "purple";
            default:
                return exhaustiveGuard(status);
        }
    }

    return <StatusChip value={translateString(getProcessStatusTranslationKey(props.status))} status={getChipColor(props.status)} />;
}

export default ProcessStatusChip;
